export default __webpack_public_path__ + "static/media/logoWhite.8bf64ac7.svg";